/* Protein Center — barra premi e prodotti consigliati del carrello.
   Si aggiorna leggendo /cart.js dopo ogni richiesta al carrello (aggiunte, quantità, rimozioni),
   da qualunque parte arrivi: pulsanti del tema, barra fissa, carosello o app. */
(function () {
  if (window.PCCart) return;

  function money(cents, format) {
    var n = (cents / 100).toFixed(2);
    var comma = n.replace('.', ',');
    var fmt = format || '€{{amount_with_comma_separator}}';
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, comma.split(',')[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, n.split('.')[0])
      .replace(/\{\{\s*amount\s*\}\}/, n);
  }

  function paintRewards(el, cart) {
    var s1 = Number(el.dataset.s1), s2 = Number(el.dataset.s2);
    var total = cart.total_price;
    var fill = el.querySelector('[data-pc-rw-fill]');
    var msgEl = el.querySelector('[data-pc-rw-msg]');
    var bar = el.querySelector('[data-pc-rw-bar]');
    var fmt = el.dataset.moneyFormat;

    fill.style.width = Math.min(100, total / s2 * 100) + '%';
    if (bar) bar.setAttribute('aria-valuenow', (total / 100).toFixed(2));

    var msg;
    if (total >= s2) msg = el.dataset.done;
    else if (total >= s1) msg = el.dataset.todo2.replace('[importo]', money(s2 - total, fmt));
    else msg = el.dataset.todo1.replace('[importo]', money(s1 - total, fmt));
    if (msgEl.textContent !== msg) {
      msgEl.textContent = msg;
      msgEl.classList.remove('is-pop'); void msgEl.offsetWidth; msgEl.classList.add('is-pop');
    }

    [[1, s1], [2, s2]].forEach(function (st) {
      var step = el.querySelector('[data-pc-rw-step="' + st[0] + '"]');
      if (!step) return;
      var on = total >= st[1];
      if (on && !step.classList.contains('is-on')) {
        step.classList.add('is-on', 'is-new');
        setTimeout(function () { step.classList.remove('is-new'); }, 900);
      } else if (!on) {
        step.classList.remove('is-on');
      }
    });
  }

  function paintUpsell(el, cart) {
    var ids = cart.items.map(function (i) { return String(i.product_id); });
    el.querySelectorAll('[data-pc-up-card]').forEach(function (card) {
      card.classList.toggle('is-hidden', ids.indexOf(card.dataset.pcUpCard) > -1);
    });
    var visible = el.querySelectorAll('[data-pc-up-card]:not(.is-hidden)').length;
    el.hidden = visible === 0 || cart.item_count === 0;
  }

  function bindUpsell(el) {
    if (el.dataset.pcBound) return;
    el.dataset.pcBound = '1';
    var rail = el.querySelector('[data-pc-up-rail]');
    el.querySelectorAll('[data-pc-up-dir]').forEach(function (b) {
      b.addEventListener('click', function () {
        rail.scrollBy({ left: rail.clientWidth * 0.85 * Number(b.dataset.pcUpDir), behavior: 'smooth' });
      });
    });
  }

  /* ---------- codice sconto ---------- */
  var lastCart = null;

  // Il tema ridisegna totali e sconti solo dopo un suo aggiornamento: si ripete la quantità
  // attuale di una riga, che non cambia nulla ma fa ricaricare il riepilogo.
  function redrawTotals(scope) {
    var item = scope.querySelector('[data-cart-item]') || document.querySelector('[data-cart-item]');
    if (!item) return;
    var qty = item.querySelector('[data-quantity-field]');
    item.dispatchEvent(new CustomEvent('theme:cart:update', {
      bubbles: true,
      detail: { id: item.getAttribute('data-id'), quantity: qty ? Number(qty.value) : 1 }
    }));
  }

  function paintCodes(el, cart) {
    var box = el.querySelector('[data-pc-dc-codes]');
    var codes = (cart.discount_codes || []).filter(function (d) { return d.applicable; });
    box.innerHTML = '';
    codes.forEach(function (d) {
      var chip = document.createElement('span');
      chip.className = 'pc-dc__chip';
      chip.textContent = d.code;
      var x = document.createElement('button');
      x.type = 'button';
      x.setAttribute('aria-label', 'Rimuovi il codice ' + d.code);
      x.textContent = '×';
      x.addEventListener('click', function () { say(el, '', false); setCodes(el, codes.map(function (c) { return c.code; }).filter(function (c) { return c !== d.code; }), null); });
      chip.appendChild(x);
      box.appendChild(chip);
    });
  }

  function say(el, text, ok) {
    var m = el.querySelector('[data-pc-dc-msg]');
    m.hidden = !text;
    m.textContent = text || '';
    m.classList.toggle('is-ok', !!ok);
  }

  function setCodes(el, list, tried) {
    var btn = el.querySelector('[data-pc-dc-apply]');
    btn.classList.add('is-loading');
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: list.join(',') })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        btn.classList.remove('is-loading');
        if (tried) {
          var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === tried.toLowerCase(); })[0];
          if (hit && hit.applicable) {
            say(el, 'Codice ' + hit.code + ' applicato 💪🏼', true);
            el.querySelector('[data-pc-dc-input]').value = '';
          } else {
            say(el, 'Il codice "' + tried + '" non è valido o non si applica a questo carrello.', false);
            // Un codice non applicabile resta nel carrello di Shopify: si toglie per non confondere il checkout.
            var good = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
            if (good.length !== (cart.discount_codes || []).length) {
              return setCodes(el, good, null);
            }
          }
        }
        paintCodes(el, cart);
        redrawTotals(el.closest('[data-cart-drawer], main') || document);
        refresh();
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        say(el, 'Non è stato possibile applicare il codice. Riprova.', false);
      });
  }

  function bindDiscount(el) {
    if (el.dataset.pcBound) return;
    el.dataset.pcBound = '1';
    var input = el.querySelector('[data-pc-dc-input]');
    var apply = function () {
      var code = input.value.trim();
      if (!code) { input.focus(); return; }
      var current = lastCart ? (lastCart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; }) : [];
      if (current.map(function (c) { return c.toLowerCase(); }).indexOf(code.toLowerCase()) > -1) {
        say(el, 'Il codice ' + code + ' è già applicato.', true);
        return;
      }
      setCodes(el, current.concat(code), code);
    };
    el.querySelector('[data-pc-dc-apply]').addEventListener('click', apply);
    // Invio nel campo non deve far partire il checkout del modulo che lo contiene.
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); apply(); }
    });
  }

  var pending = null;
  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          lastCart = cart;
          document.querySelectorAll('[data-pc-discount]').forEach(function (el) { bindDiscount(el); paintCodes(el, cart); });
          document.querySelectorAll('[data-pc-rewards]').forEach(function (el) { paintRewards(el, cart); });
          document.querySelectorAll('[data-pc-upsell]').forEach(function (el) { bindUpsell(el); paintUpsell(el, cart); });
        })
        .catch(function () {});
    }, 120);
  }

  // Ogni chiamata al carrello, anche fatta da app o dal tema, fa ridisegnare barra e carosello.
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          if (/\/cart\/(add|change|update|clear)(\.js)?/.test(e.name)) refresh();
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
  }
  ['theme:cart:open', 'theme:cart:added', 'theme:cart:loaded', 'theme:cart:update'].forEach(function (ev) {
    document.addEventListener(ev, refresh);
  });
  // Il corpo del carrello laterale viene creato alla prima apertura: quando compare, si disegna.
  var drawer = document.querySelector('[data-cart-drawer]');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (drawer.querySelector('[data-pc-rewards]:not([data-pc-seen])')) {
        drawer.querySelectorAll('[data-pc-rewards]').forEach(function (el) { el.setAttribute('data-pc-seen', ''); });
        refresh();
      }
    }).observe(drawer, { childList: true, subtree: true });
  }

  window.PCCart = { refresh: refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();
